import React, { useContext } from 'react';

import { SendContext } from '../../SendContext';
import {EvoachButton} from "../Button";

import { SceneCanvasContext } from './SceneCanvasContext';
import { SceneDisplay } from './SceneDisplay';
import { Character } from './types';

export interface SceneCanvasStartProps {
  isEcho: boolean;
  buttonText: string;
  saveResultTo: string;
}

// SceneCanvasStart
// exists because it contains the "next" button for non-echo calls.
// Furthermore, it consumes the context to retrieve changed elements
export const SceneCanvasStart: React.FC<SceneCanvasStartProps> = ({
  isEcho,
  buttonText,
  saveResultTo,
}) => {
  const { send } = useContext(SendContext);
  const { characters } = useContext(SceneCanvasContext);

  return (
    <>
      <SceneDisplay />
      {!isEcho && (
        <EvoachButton
          onClick={() => {
            send({
              type: 'writeToContext',
              payload: {
                [saveResultTo]: characters.map((character: Character) => {
                  return { ...character, assetPath: undefined };
                }),
              },
            });
            send({ type: 'next' });
          }}
        >
          {buttonText}
        </EvoachButton>
      )}
    </>
  );
};
